<!-- Invoice -->
@if (showHeader()) {
  <div
    class="flex align-items-center justify-content-between cursor-pointer"
    pStyleClass="@next"
    enterFromClass="hidden"
    enterActiveClass="scalein"
    leaveToClass="hidden"
    leaveActiveClass="fadeout"
    [hideOnOutsideClick]="true"
  >
    <div class="flex align-items-center justify-content-center">
      <div
        class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center"
      >
        <i class="fa fa-file-invoice"></i>
      </div>
      <div class="ml-3">
        <h4 class="text-base mb-0 line-height-1 font-bold">
          {{ 'TRANSACTION.INVOICES' | translate }}
        </h4>
        @if (!loading && invoiceData$ | async) {
          <p class="mb-0 text-xs text-600">
            {{ totalItems$.value }}
            {{ 'TRANSACTION.INVOICES_GENE' | translate }}
          </p>
        }
        @if (loading) {
          <p-skeleton width="7rem" height="0.9rem" styleClass="mt-1" />
        }
      </div>
    </div>
    <i class="fa fa-circle-chevron-down text-primary"></i>
  </div>
}

<div [ngClass]="showHeader() ? 'hidden mt-2' : ''">
  <!-- Content -->
  <app-data-grid
    [columnData]="invoiceData$"
    [columns]="invoiceTablecolumns$"
    [selectable]="selecallInvoiceData"
    [totalRecords]="totalRecordLength"
    (emitValue)="handleEvent($event)"
    (emitSelectValue)="handleSelectAll($event)"
    tableClasses="shadow-2 p-0 my-3"
    [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
    (loadNextData)="fetchNextSetData($event)"
    (onAction)="onActionEvent($event)"
    [EmptyState]="emptyStateComponent$"
    [paginator]="true"
    [loading]="loading"
    [gridName]="'invoice-list'"
  />
  <!-- Content -->
</div>

<!-- Invoice -->

<!-- Void Invoice Modal -->
<p-dialog
  [visible]="showVoidInvoiceModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form [formGroup]="voidInvoiceForm">
      <div class="relative text-center p-4">
        <div
          class="fa fa-times opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidInvoiceModal = false"
        ></div>

        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
        />

        <h4 class="text-base md:text-lg my-3 font-bold">
          {{ 'INVOICE.INVOICE_DEL_CONFI' | translate }} <br />
          {{ invoiceDetails.number_prefix }} ?
        </h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">
          {{ 'INVOICE.INVOICE_DEL_INFO' | translate }}
        </p>
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'INVOICE.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (VoidReasonFormControl.touched && VoidReasonFormControl.invalid) {
          <app-error-msg
            [errors]="VoidReasonFormControl.errors"
            [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="showVoidInvoiceModal = false"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'INVOICE.VOID_LABEL' | translate"
          class="p-button-danger text-sm"
          [loading]="btnLoading"
          (click)="deleteInvoice(voidInvoiceForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Void Invoice Modal -->

<!-- Send Link - Collect Dues  -->
<p-dialog
  [visible]="sendLinkCollectDues"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '95vw' }"
  [style]="{ width: '400px', 'max-width': '95vw' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Modal Header -->
    <div
      class="px-3 pt-3 pb-2 flex align-items-center justify-content-between border-bottom-1 border-200"
    >
      <h2 class="mb-0 text-sm font-semibold text-900">
        {{
          'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHEADERINV' | translate
        }}
      </h2>
      <i
        class="fa fa-times text-lg text-500 cursor-pointer hover:text-700 transition-colors transition-duration-150"
        aria-label="close-dialog"
        (click)="closeSendLinkDialog()"
      ></i>
    </div>

    <!-- Content -->
    <div class="p-3">
      <p class="text-xs text-600 mb-3 line-height-3">
        {{ 'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTINVOICEDUE' | translate }}
      </p>

      <label class="text-xs text-700 mb-2 block font-medium">{{
        'SUBSCRIPTIONS.COLLECTDUES_SENDON' | translate
      }}</label>

      <!-- Compact Button Grid -->
      <div class="flex flex-column gap-2">
        <!-- Email Button -->
        <button
          type="button"
          [ngClass]="
            emailSelected
              ? 'p-button-primary shadow-1'
              : 'p-button-outlined surface-border'
          "
          (click)="toggleChannel('email')"
          class="w-full justify-content-start px-3 py-2 border-1 transition-all transition-duration-150 hover:shadow-2"
          pButton
          pRipple
          aria-label="email-option"
        >
          <div class="flex align-items-center gap-2 w-full">
            <i
              class="fa fa-envelope text-base"
              [ngClass]="emailSelected ? 'text-white' : 'text-primary'"
            ></i>
            <span class="flex-1 text-left text-sm">
              {{ 'SUBSCRIPTIONS.COLLECTDUES_EMAIL' | translate }}
            </span>
            @if (emailSelected) {
              <i class="fa fa-check-circle text-white text-sm"></i>
            }
          </div>
        </button>

        <!-- SMS Button -->
        <button
          type="button"
          [ngClass]="
            smsSelected
              ? 'p-button-primary shadow-1'
              : 'p-button-outlined surface-border'
          "
          (click)="toggleChannel('sms')"
          class="w-full justify-content-start px-3 py-2 border-1 transition-all transition-duration-150 hover:shadow-2"
          pButton
          pRipple
          aria-label="sms-option"
        >
          <div class="flex align-items-center gap-2 w-full">
            <i
              class="fa fa-comments text-base"
              [ngClass]="smsSelected ? 'text-white' : 'text-primary'"
            ></i>
            <span class="flex-1 text-left text-sm">
              {{ 'SUBSCRIPTIONS.COLLECTDUES_SMS' | translate }}
            </span>
            @if (smsSelected) {
              <i class="fa fa-check-circle text-white text-sm"></i>
            }
          </div>
        </button>

        <!-- WhatsApp Button -->
        <button
          type="button"
          [ngClass]="
            whatsappSelected
              ? 'p-button-primary shadow-1'
              : 'p-button-outlined surface-border'
          "
          (click)="toggleChannel('whatsapp')"
          class="w-full justify-content-start px-3 py-2 border-1 transition-all transition-duration-150 hover:shadow-2"
          pButton
          pRipple
          aria-label="whatsapp-option"
        >
          <div class="flex align-items-center gap-2 w-full">
            <i
              class="fab fa-whatsapp text-base"
              [ngClass]="whatsappSelected ? 'text-white' : 'text-primary'"
            ></i>
            <span class="flex-1 text-left text-sm">
              {{ 'SUBSCRIPTIONS.COLLECTDUES_WHATSAPP' | translate }}
            </span>
            @if (whatsappSelected) {
              <i class="fa fa-check-circle text-white text-sm"></i>
            }
          </div>
        </button>

        <!-- Mobile Notification Button -->
        <button
          type="button"
          [ngClass]="
            mobileNotificationSelected
              ? 'p-button-primary shadow-1'
              : 'p-button-outlined surface-border'
          "
          (click)="toggleChannel('mobileNotification')"
          class="w-full justify-content-start px-3 py-2 border-1 transition-all transition-duration-150 hover:shadow-2"
          pButton
          pRipple
          aria-label="mobile-notification-option"
        >
          <div class="flex align-items-center gap-2 w-full">
            <i
              class="fa fa-bell text-base"
              [ngClass]="
                mobileNotificationSelected ? 'text-white' : 'text-primary'
              "
            ></i>
            <span class="flex-1 text-left text-sm">
              {{ 'SUBSCRIPTIONS.SEND_PUSH_NOTIFICATION_LINK' | translate }}
            </span>
            @if (mobileNotificationSelected) {
              <i class="fa fa-check-circle text-white text-sm"></i>
            }
          </div>
        </button>
      </div>

      <!-- Compact Selection Info -->
      @if (getSelectedChannelsCount() > 0) {
        <div
          class="mt-2 p-2 surface-50 border-round flex align-items-center gap-2"
        >
          <i class="fa fa-info-circle text-primary text-xs"></i>
          <span class="text-xs text-600">
            {{ getSelectedChannelsCount() }} channel(s) selected
          </span>
        </div>
      }
    </div>

    <!-- Modal Footer -->
    <div
      class="px-3 pb-3 pt-2 border-top-1 border-200 flex align-items-center justify-content-end gap-2"
    >
      <p-button
        pRipple
        type="button"
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        styleClass="p-button-text p-button-sm"
        aria-label="cancel-button"
        (click)="closeSendLinkDialog()"
      />

      <p-button
        pRipple
        type="button"
        [label]="'SUBSCRIPTIONS.BTN_SEND' | translate"
        [loading]="sendLinkLoading"
        [disabled]="getSelectedChannelsCount() === 0"
        styleClass="p-button-sm"
        aria-label="send-button"
        (click)="SendCollectDuesLink($event)"
      />
    </div>
  </ng-template>
</p-dialog>
<!-- Send Link - Collect Dues -->

@if (showPayment) {
  <payment
    [showPayment]="showPayment"
    [invoiceDetailById]="invoiceClientdataObject"
    (GoToClientSubscription)="GoToClientDetails($event)"
    (hidePaymentSidebar)="HidePaymemt($event)"
    closeOnEscape="false"
  />
}

@if (showChangeBillOwner | async; as showPopup) {
  <change-bill-owner
    [visible]="showPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [invoiceData]="invoiceDetails"
    (closeDialog)="closeDialogEvent($event)"
  />
}

@if (createSalesReturn | async; as showPopup) {
  <create-sales-return
    [visible]="showPopup"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [invoiceData]="invoiceById"
    (closeDialog)="closeSalesReturnDialogEvent($event)"
    [invoiceId]="invoiceId"
  />
}

@if (showWriteOff.value || showWriteOffList.value) {
  <write-off
    [visible]="showWriteOff.value"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    [showList]="showWriteOffList.value"
    [invoiceData]="invoiceDetails"
    (closeDialog)="closeWriteOffDialogEvent($event)"
    [clientId]="clientId()"
    [tenantId]="tenantId()"
  />
}
